/**
 * Refonte Achats · Stock WP-13 (A-11, 03_DATABASE DB-12, ux/04 §3.1) — the ONE text normaliser of
 * the product search. Used to write `search_text` (Produit, NomenclatureProduit), to normalise a
 * query, by the offline store and by the highlighter, so the same input always folds the same way.
 *
 *   · lower-case; diacritics stripped (NFD); the ligatures œ / æ / ß spelled out;
 *   · a decimal comma between two digits is a point (« 0,02 » ≡ « 0.02 », UX OP-PSA-31); a point
 *     anywhere else is punctuation;
 *   · « % » is a literal character (« BETADINE 10% », AUD-SRCH-18); every other non-letter,
 *     non-digit character (« / », « - », « _ », « \ », « ( », « ' »…) is a separator;
 *   · runs of separators collapse into one space, trimmed.
 *
 * Unit equivalence (g ↔ mg) is deliberately NOT applied: a domain rule not to invent (OP-PSA-31).
 * Pure functions, no import outside this folder (the server runs a byte-identical copy).
 */

const DIACRITIQUES = /\p{M}/gu;
const LIGATURES = Object.freeze({ "\u0153": "oe", "\u00e6": "ae", "\u00df": "ss", "\u00f8": "o", "\u0142": "l", "\u0111": "d", "\u0131": "i" });
const LIGATURE_RE = /[\u0153\u00e6\u00df\u00f8\u0142\u0111\u0131]/g;
const VIRGULE_DECIMALE = /(\d),(?=\d)/g;
const SEPARATEURS = /[^\p{L}\p{N}%.]+/gu;
const POINT_NON_DECIMAL = /(?<!\d)\.|\.(?!\d)/g;
const ESPACES = / {2,}/g;

/** One character folded (lower-case, no diacritic, ligature spelled out); may return "" or 2 chars. */
export function plierCaractere(c) {
  const bas = c.toLowerCase().normalize("NFD").replace(DIACRITIQUES, "");
  return bas.replace(LIGATURE_RE, (l) => LIGATURES[l]);
}

/**
 * The normalised form of any value (string, number, null…): see the module comment.
 * @param {unknown} valeur
 * @returns {string}
 */
export function normaliserRecherche(valeur) {
  if (valeur == null) return "";
  return String(valeur)
    .toLowerCase()
    .normalize("NFD")
    .replace(DIACRITIQUES, "")
    .replace(LIGATURE_RE, (l) => LIGATURES[l])
    .replace(VIRGULE_DECIMALE, "$1.")
    .replace(SEPARATEURS, " ")
    .replace(POINT_NON_DECIMAL, " ")
    .replace(ESPACES, " ")
    .trim();
}

/** The normalised form without any space (exact comparison of codes and N° ENR). */
export function compacterRecherche(valeur) {
  return normaliserRecherche(valeur).replace(/ /g, "");
}
